import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 3000 }
  };

  connect() {
    this.timeout = setTimeout(() => {
      this.redirect()
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  redirect() {
    if (this.hasUrlValue) {
      window.location.href = this.urlValue
    }
  }
}
